import { Button } from "./Button";
import { usePlanningBaseline } from "./DesignSystem";
import { LoaderCircle } from "lucide-react";
import "./pages.css";

export function PageState({ title, description, busy = false, retry, retryLabel = "다시 연결" }: { title?: string; description?: string; busy?: boolean; retry?: () => void; retryLabel?: string }) {
  const planningBaseline = usePlanningBaseline();
  if (busy) {
    return <main className="ui-page-state is-loading load-state">
      {/* Home/planner retain the source layout preview, including authentication,
          data loading and Suspense. Other routes keep their current feedback. */}
      <div role={retry ? "alert" : "status"} aria-label={planningBaseline || !title ? "불러오는 중" : undefined} className="ui-page-loading">
        {/* 2026-10-18 (사용자 결정): 홈·플래너 전체 화면 로딩은 Claude 처럼 가운데 원 하나.
            Claude 원본 = Spinner 글리프 · md · spin 1s linear infinite · text-secondary(#52514E).
            글리프는 전용 폰트라 Lucide LoaderCircle 로 같은 크기·속도·색을 맞춘다. */}
        {planningBaseline ? <LoaderCircle className="ui-page-spinner" size={20} aria-hidden="true" /> : <>
          <span className="ui-loading-indicator" aria-hidden="true" />
          {title && <span>{title}</span>}
          {description && <span>{description}</span>}
        </>}
      </div>
      {/* 홈·플래너는 원 하나만 선다 (2026-10-18 사용자 지시) — "화면 다시 불러오기" 단추를 걷는다. */}
      {retry && !planningBaseline && <Button variant="primary" onClick={retry}>{retryLabel}</Button>}
    </main>;
  }
  return <main className="ui-page-state load-state">
    <div role={retry ? "alert" : "status"}>
      {title && <h1>{title}</h1>}{description && <p>{description}</p>}
    </div>
    {retry && <Button variant="primary" onClick={retry}>{retryLabel}</Button>}
  </main>;
}
